<mat-icon
  [svgIcon]="getIconNameForProductionScheduleStatus()"
  [class]="getIconColorNameForProductionScheduleStatus()"
  class="flex-no-shrink flex-row"
  [class.icon-16]="withSmallSize"
  [matTooltip]="getTooltip()"
  matTooltipPosition="above"
></mat-icon>
